import { Injectable } from '@angular/core';

import { Observable, map, tap, of, catchError } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { AreaDetailsRequest } from '../../models/remote.request/AreaDetailsRequest';
import { SaveAreaDetailsResponse } from '../../models/remote.response/SaveAreaDetailsResponse';
import { AuthenticateUserRequest } from '../../models/remote.request/AuthenticateUserRequest';
import { AuthenticateUserResponse } from '../../models/remote.response/AuthenticateUserResponse';
import { CloseUserSessionResponse } from '../../models/remote.response/CloseUserSessionResponse';
import { DeleteAreaDetailsResponse } from '../../models/remote.response/DeleteAreaDetailsResponse';
import { GetAreaDetailsResponse } from '../../models/remote.response/GetAreaDetailsResponse';
import { AreaListFilterRequest } from '../../models/remote.request/AreaListFilterRequest';
import { GetAreaListByFilterResponse } from '../../models/remote.response/GetAreaListByFilterResponse';
import { DriverListFilterRequest } from '../../models/remote.request/DriverListFilterRequest';
import { GetDriverListForFilterResponse } from '../../models/remote.response/GetDriverListForFilterResponse';
import { GetDriverListResponse } from '../../models/remote.response/GetDriverListResponse';
import { GetEcoDrivingListResponse } from '../../models/remote.response/GetEcoDrivingListResponse';
import { GetEventActionListResponse } from '../../models/remote.response/GetEventActionListResponse';
import { GetEventDetailsResponse } from '../../models/remote.response/GetEventDetailsResponse';
import { EventListFilterRequest } from '../../models/remote.request/EventListFilterRequest';
import { GetEventListByFilterResponse } from '../../models/remote.response/GetEventListByFilterResponse';
import { GetEventNotificationResponse } from '../../models/remote.response/GetEventNotificationResponse';
import { GetProfileContactDataResponse } from '../../models/remote.response/GetProfileContactDataResponse';
import { GetProfileUserDataResponse } from '../../models/remote.response/GetProfileUserDataResponse';
import { GetRouteAvailableDatesResponse } from '../../models/remote.response/GetRouteAvailableDatesResponse';
import { RouteListFilterRequest } from '../../models/remote.request/RouteListFilterRequest';
import { GetRouteListByFilterResponse } from '../../models/remote.response/GetRouteListByFilterResponse';
import { SMSListFilterRequest } from '../../models/remote.request/SMSListFilterRequest';
import { GetRouteStatsByFilterResponse } from '../../models/remote.response/GetRouteStatsByFilterResponse';
import { TagsListFilterRequest } from '../../models/remote.request/TagsListFilterRequest';
import { GetTagsListByFilterResponse, IUntaggedAreas } from '../../models/remote.response/GetTagsListByFilterResponse';
import { VehicleListFilterRequest } from '../../models/remote.request/VehicleListFilterRequest';
import { GetVehicleListByFilterResponse } from '../../models/remote.response/GetVehicleListByFilterResponse';
import { GetSMSListByFilterResponse } from '../../models/remote.response/GetSMSListByFilterResponse';
import { GetVehicleListResponse } from '../../models/remote.response/GetVehicleListResponse';
import { GetVehicleParamListResponse } from '../../models/remote.response/GetVehicleParamListResponse';
import { ResetEventNotificationResponse } from '../../models/remote.response/ResetEventNotificationResponse';
import { ResetPasswordResponse } from '../../models/remote.response/ResetPasswordResponse';
import { SendSMSResponse } from '../../models/remote.response/SendSMSResponse';
import { SendSMSRequest } from '../../models/remote.request/SendSMSRequest';
import { SetPasswordRequest } from '../../models/remote.request/SetPasswordRequest';
import { RemoteDataService } from '../remote.data/remote-data.service';
import { GetSystemUpdateInfoListResponse } from '../../models/remote.response/GetSystemUpdateInfoListResponse';
import { SetUserEmailRequest } from '../../models/remote.request/SetUserEmailRequest';
import { SetUserEmailResponse } from '../../models/remote.response/SetUserEmailResponse';
import { SetSendToETollRequest } from '../../models/remote.request/SetSendToETollRequest';
import { SetSendToETollResponse } from '../../models/remote.response/SetSendToETollResponse';
import { GetSendToETollResponse } from '../../models/remote.response/GetSendToETollResponse';
import { UpdateVehicleNameResponse } from '../../models/remote.response/UpdateVehicleNameResponse';
import { UpdateVehicleNameRequest } from '../../models/remote.request/UpdateVehicleNameRequest';
import { IWebAccessService } from '../../interfaces/IWebAccessService';
import { SetProfileUserPasswordResponse } from '../../models/remote.response/SetProfileUserPasswordResponse';

import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import { HttpHeaders } from '@angular/common/http';
import { IGetLockVehicleState, ISetLockVehicleState, IVehicleHistoryResponse } from '@commons/models/remote.request/VehicleLock';
import { PermissionService } from '@shared/services/permission.service';
import { IMaxFuelVehicle, IVehicleSentGeo, SetSentGeoStatusPostData } from '@src/app/interfaces/vehicle.interface';
import { WebResponse } from '@commons/models/remote.response/WebResponse';
import { GetParameterValueListPostdata, IGetChartData } from '@src/app/interfaces/chart-params.interface';
import { IRiskCategory } from '@commons/interfaces/vehicle.interface';

@Injectable()
export class WebAccessService implements IWebAccessService {

    private readonly baseUrl = environment.hammerApiUrl;

    constructor(
        private $service: RemoteDataService,
        private permissionService: PermissionService,
    ) {}

    AddAreaDetails(area: AreaDetailsRequest): Observable<SaveAreaDetailsResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/AddAreaDetails';

        // przesłanie do usługi
        return this.$service.httpPost(url, area).pipe(map(x => <SaveAreaDetailsResponse>x));
    }
    AuthenticateUser(request: AuthenticateUserRequest): Observable<AuthenticateUserResponse> {
        request.Platform = 'web';
        // url do pobrania
        const url = environment.hammerApiUrl + '/AuthenticateUser';
        const noCredentials = request.DB ? true : false;
        const headers = new HttpHeaders({
            ClientName: request.DB || '',
        });
        // przesłanie do usługi
        return this.$service.httpPost(url, request, { notification: false, noCredentials: noCredentials, headers })
          .pipe(map(x => <AuthenticateUserResponse>x));
    }
    CloseUserSession(sessionId: string): Observable<CloseUserSessionResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/CloseUserSession';

        // przesłanie do usługi
        return this.$service.httpPost(url, { SessionId: sessionId }).pipe(map(x => <CloseUserSessionResponse>{}));
    }
    DeleteAreaDetails(areaId: number): Observable<DeleteAreaDetailsResponse> {

        // url do pobrania
        const url = environment.hammerApiUrl + '/DeleteAreaDetails/' + areaId;

        // przesłanie do usługi
        return this.$service.httpDelete(url).pipe(map(x => <DeleteAreaDetailsResponse>{}));
    }
    GetAreaDetails(areaId: number): Observable<GetAreaDetailsResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetAreaDetails/' + areaId;

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(map(x => <GetAreaDetailsResponse>x));
    }
    GetAreaListByFilter(filter: AreaListFilterRequest): Observable<GetAreaListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetAreaListByFilter';

        // przesłanie do usługi
        return this.$service.httpPost(url, filter).pipe(map(x => <GetAreaListByFilterResponse>x));
    }
    GetDriverIdListForFilter(filter: DriverListFilterRequest): Observable<GetDriverListForFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetDriverIdListForFilter';

        // przesłanie do usługi
        return this.$service.httpPost(url, filter).pipe(map(x => <GetDriverListForFilterResponse>x));
    }
    GetDriverList(): Observable<GetDriverListResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetDriverList';

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(map(x => <GetDriverListResponse>x));
    }
    GetEcoDrivingList(driverId: number): Observable<GetEcoDrivingListResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetEcoDrivingList/' + driverId;

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(map(x => <GetEcoDrivingListResponse>x));
    }
    GetEventActionList(eventType: number): Observable<GetEventActionListResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetEventActionList';
        const filter = {
            EventType: eventType
        };

        // przesłanie do usługi
        return this.$service.httpPost(url, filter).pipe(map(x => <GetEventActionListResponse>x));
    }
    GetEventDetails(eventId: number): Observable<GetEventDetailsResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetEventDetails?eventId=' + eventId;

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(map(x => <GetEventDetailsResponse>x));
    }
    GetEventListByFilter(filter: EventListFilterRequest): Observable<GetEventListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetEventListByFilter';

        // przesłanie do usługi
        return this.$service.httpPost(url, filter).pipe(map(x => {
                const r = <GetEventListByFilterResponse>x;
                r.EventType = filter.EventType;
                return r;
            }));
    }
    GetEventNotification(): Observable<GetEventNotificationResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetEventNotification';

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(map(x => <GetEventNotificationResponse>x));
    }
    GetSystemUpdateInfoList(): Observable<GetSystemUpdateInfoListResponse> {
        return new Observable<GetSystemUpdateInfoListResponse>(observer => {
            // url do pobrania
            const url = environment.hammerApiUrl + '/GetSystemUpdateInfoList';

            // // przesłanie do usługi
            // this.$service.httpGet(url)
            //     .map(result => <GetSystemUpdateInfoListResponse>result)
            //     .subscribe(result => {
            //         observer.next(result);
            //         observer.complete();
            //     });
            const result = {} as GetSystemUpdateInfoListResponse;
            result.Result = [];
            observer.next(result);
            observer.complete();
        });
    }
    GetProfileContactData(notify?: boolean): Observable<GetProfileContactDataResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetProfileContactData';
        notify = notify || true;

        // przesłanie do usługi
        return this.$service.httpGet(url, { notification: notify }).pipe(map(x => <GetProfileContactDataResponse>x));
    }
    GetProfileUserData(notify?: boolean): Observable<GetProfileUserDataResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetProfileUserData';
        notify = notify || true;

        // przesłanie do usługi
        return this.$service.httpPost(url, { notification: notify }).pipe(map(x => <GetProfileUserDataResponse>x));
    }


    GetRouteAvailableDates(vehicleId: number, year: number, month: number): Observable<GetRouteAvailableDatesResponse> {

        // url do pobrania
        const url = environment.hammerApiUrl +
            '/GetRouteAvailableDates/' + vehicleId + '/' + year + '/' + month;

        // przesłanie do usługi
        return this.$service.httpGet(url).pipe(
          tap((x: any) => x.Result = x.Result.MyProperty),
          map(x => <GetRouteAvailableDatesResponse>x)
        );
    }

    GetRouteListByFilter(filter: RouteListFilterRequest): Observable<GetRouteListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetRouteListByFilter';
        filter.DateFrom = filter.DateFrom;
        filter.DateTo = filter.DateTo;

        // przesłanie do usługi
        return this.$service.httpPost(url, { VehicalID: filter.VehicleId, DateFrom: filter.DateFrom, DateTo: filter.DateTo, GetDriverAndNotes: filter.GetDriverAndNotes })
          .pipe(map(x => <GetRouteListByFilterResponse>x));
    }
    GetRouteStatsByFilter(filter: RouteListFilterRequest): Observable<GetRouteStatsByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetRouteStatsByFilter';
        filter.DateFrom = filter.DateFrom;
        filter.DateTo = filter.DateTo;

        // przesłanie do usługi
        return this.$service.httpPost(url, { VehicalID: filter.VehicleId, DateFrom: filter.DateFrom, DateTo: filter.DateTo })
          .pipe(map(x => <GetRouteStatsByFilterResponse>x));
    }
    GetSMSListByFilter(filter: SMSListFilterRequest): Observable<GetSMSListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetSMSListByFilter';

        // przesłanie do usługi
        return this.$service.httpPost(url, filter, { notification: false })
          .pipe(map(x => <GetSMSListByFilterResponse>x));
    }
    GetTagsListByFilter(filter: TagsListFilterRequest): Observable<GetTagsListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetTagsListByFilter';

        // przesłanie do usługi
        return this.$service.httpPost(url, filter)
          .pipe(map(x => <GetTagsListByFilterResponse>x));
    }
    GetUntaggedAreas(filters: { Phrase: string } = { Phrase: '' }): Observable<IUntaggedAreas> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetUntaggedAreas';

        // przesłanie do usługi
        return this.$service.httpPost(url, filters)
          .pipe(map(x => x));
    }
    GetVehicleIdListByFilter(filter: VehicleListFilterRequest): Observable<GetVehicleListByFilterResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetVehicleIdListByFilter';
        const data = {...(filter || {})};

        //GB te 3 linijki to obejście błędu https://tekomtechnologia.atlassian.net/browse/MC-5117
      if (Object.keys(filter).length > 0) {
        (data as any).TachoStatuses = [];
        (data as any).ETollStatuses = [];
        (data as any).SentGeoStatus = [];
      }
        // przesłanie do usługi
        return this.$service.httpPost(url, data)
          .pipe(map(x => <GetVehicleListByFilterResponse>x));
    }
    GetVehicleList(): Observable<GetVehicleListResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetVehicleList';

        // przesłanie do usługi
        return this.$service.httpGet(url)
          .pipe(map(x => <GetVehicleListResponse>x));
    }
    GetVehicleParamList(): Observable<GetVehicleParamListResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/GetVehicleParamList';

        // przesłanie do usługi
        return this.$service.httpGet(url)
          .pipe(map(x => <GetVehicleParamListResponse>x));
    }
    ResetEventNotification(): Observable<ResetEventNotificationResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/ResetEventNotification';

        // przesłanie do usługi
        return this.$service.httpPost(url).pipe(map(x => <ResetEventNotificationResponse>x));
    }
    resetPassword(email: string): Observable<ResetPasswordResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/ResetPassword';

        // przesłanie do usługi
        return this.$service.httpPost(url, { Email: email, Prod: environment.production }, { notification: false })
          .pipe(map(x => <ResetPasswordResponse>x));
    }
    ResetPasswordConfirm(passwordChange: SetPasswordRequest): Observable<ResetPasswordResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/ResetPasswordConfirm';

        // przesłanie do usługi
        return this.$service.httpPost(url, passwordChange, { notification: false })
          .pipe(map(x => <ResetPasswordResponse>x));
    }
    SendSMS(request: SendSMSRequest): Observable<SendSMSResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/SendSMS';

        // przesłanie do usługi
        return this.$service.httpPost(url, request)
          .pipe(map(x => <SendSMSResponse>x));
    }
    SetProfileUserPassword(passwordChange: SetPasswordRequest): Observable<SetProfileUserPasswordResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/SetProfileUserPassword';

        const _passwordChange = JSON.parse(JSON.stringify(passwordChange));
        _passwordChange.Prod = environment.production;

        // przesłanie do usługi
        return this.$service.httpPost(url, _passwordChange, { notification: false })
          .pipe(map(x => <SetProfileUserPasswordResponse>x));
    }
    SetUserEmail(request: SetUserEmailRequest): Observable<SetUserEmailResponse> {
        const url = environment.hammerApiUrl + '/SetUserEmail';

        return this.$service.httpPost(url, request)
          .pipe(map(x => <SetUserEmailResponse>x));
    }
    UpdateAreaDetails(area: AreaDetailsRequest): Observable<SaveAreaDetailsResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/UpdateAreaDetails';

        // przesłanie do usługi
        return this.$service.httpPut(url, area)
          .pipe(map(x => <SaveAreaDetailsResponse>x));
    }

    SetSendToEToll(sendToEToll: SetSendToETollRequest): Observable<SetSendToETollResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/SetSendToEToll';

        // przesłanie do usługi
        return this.$service.httpPost(url, sendToEToll)
          .pipe(map(x => <SetSendToETollResponse>x));
    }
    GetSendToEToll(idVehice: number): Observable<GetSendToETollResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl +
            '/GetSendToEToll/' + idVehice;

        // przesłanie do usługi
        return this.$service.httpGet(url)
          .pipe(map(x => <GetSendToETollResponse>x));
    }

    UpdateVehicleName(updateVehicleNameRequest: UpdateVehicleNameRequest): Observable<UpdateVehicleNameResponse> {
        // url do pobrania
        const url = environment.hammerApiUrl + '/UpdateVehicleName';

        // przesłanie do usługi
        return this.$service.httpPut(url, updateVehicleNameRequest)
          .pipe(map(x => <UpdateVehicleNameResponse>x));
    }

    SetLockVehicleState(data: ISetLockVehicleState): Observable<any> {
        const url = environment.hammerApiUrl + '/SetIgnitionBlocker';
        const timeout2Minutes = 120000;
        return this.$service.httpPost(url, data, null, timeout2Minutes);
    }

    GetLockVehicleState(vehicleId: number): Observable<IGetLockVehicleState> {
        const url = environment.hammerApiUrl + `/GetVehicleIgnitionBlockerDetails/${vehicleId}`;
        return this.$service.httpGet(url).pipe(map(item => item.Result));
    }

    GetVehicleIgnitionBlockerDetailsList(): Observable<any> {
        if (this.permissionService.hasBlockerRead() || this.permissionService.hasBlockerReadWrite()) {
            const url = environment.hammerApiUrl + `/GetVehicleIgnitionBlockerDetailsList`;
            return this.$service.httpGet(url).pipe(
                map(item => item.Result),
                catchError(() => of({ BlockerInfos: [] })),
            );
        }
        return of({ BlockerInfos: [] });
    }

    GetIgnitionBlockerAuditTrailForVehicle(vehicleId: number): Observable<IVehicleHistoryResponse> {
        const url = environment.hammerApiUrl + `/GetIgnitionBlockerAuditTrailForVehicle/${vehicleId}`;
        return this.$service.httpGet(url).pipe(map(item => item.Result));
    }

    public GetVehicleFuelCapacity(vehicleId: number): Observable<IMaxFuelVehicle> {
        const url = environment.hammerApiUrl + `/GetVehicleFuelCapacity/${vehicleId}`;
        return this.$service.httpGet(url).pipe(map(item => item.Result));
    }

    public GetSendToSentGeo(vehicleId: number): Observable<IVehicleSentGeo> {
        const url = environment.hammerApiUrl + `/GetSendToSentGeo/${vehicleId}`;
        return this.$service.httpGet(url).pipe(map(item => item.Result));
    }

    public SetSendToSentGeo(data: SetSentGeoStatusPostData): Observable<WebResponse<null>> {
        const url = environment.hammerApiUrl + `/SetSendToSentGeo`;
        return this.$service.httpPost(url, data);
    }

    public GetVehicleRoamingRiskCategory(vehicleId: number): Observable<IRiskCategory> {
        const url = environment.hammerApiUrl + `/GetVehicleRoamingInfo/${vehicleId}`;
        return this.$service.httpGet(url).pipe(map(item => item.Result));
    }

    public GetParameterValueList(data: GetParameterValueListPostdata): Observable<IGetChartData[]> {
        const url = environment.hammerApiUrl + `/GetParameterValueList`;
        return this.$service.httpPost(url, data).pipe(map(item => item.Result));
    }

}
